import React from "react"

import { PortfolioCard } from "shared/ui/portfolio-card/PortfolioCard"

export interface ExternalDimensioningBaseProductCardProps {
  image: React.ReactNode
  title?: string
  subtitle?: string
  isLoading?: boolean
}

export const ExternalDimensioningBaseProductCard = React.memo(
  ({
    image,
    title,
    subtitle,
    isLoading
  }: ExternalDimensioningBaseProductCardProps) => {
    return (
      <PortfolioCard
        isLoading={isLoading}
        className="external-dimensioning-base-product-card card--elevated"
      >
        <PortfolioCard.Body>
          <PortfolioCard.Image>{image}</PortfolioCard.Image>
          <PortfolioCard.Title>{title}</PortfolioCard.Title>
          <PortfolioCard.Subtitle>{subtitle}</PortfolioCard.Subtitle>
        </PortfolioCard.Body>
      </PortfolioCard>
    )
  }
)
